// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Nicaragua from '../_raw/flag/icon_flag_nicaragua.png';

export default () => <img src={Nicaragua} alt="Nicaragua" />;
